import { Button } from '@/components/ui/button';

const RouteErrorFallback = () => {
  const isEs = typeof window !== 'undefined' && window.location.pathname.startsWith('/es');
  return (
    <div role="alert" className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-bold text-foreground mb-3">
          {isEs ? 'Algo no cargó bien' : "Something didn't load"}
        </h1>
        <p className="text-muted-foreground mb-6">
          {isEs
            ? 'Puede que el sitio se haya actualizado. Recarga la página para ver la última versión.'
            : 'The site may have just been updated. Reload the page to get the latest version.'}
        </p>
        <Button
          onClick={() => {
            sessionStorage.removeItem('chunk-reload-attempted');
            window.location.reload();
          }}
        >
          {isEs ? 'Recargar' : 'Reload'}
        </Button>
      </div>
    </div>
  );
};

export default RouteErrorFallback;
